import { Controller } from "@hotwired/stimulus";

// Closes a native <details> dropdown when clicking outside it or pressing Escape.
export default class DropdownMenuController extends Controller {
  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.element.removeAttribute("open");
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.element.removeAttribute("open");
    }
  }
}
